import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Pencil, Trash2, LineChart, Archive } from 'lucide-react';
import { fmtCurrency } from '../../lib/localeUtils';
import { METHOD_LABELS } from './assetConstants';

const Row = ({ a, labels, onEdit, onSchedule, onDispose, onDelete }) => {
  const active = a.status === 'active';
  return (
    <tr className="border-t" data-testid={`asset-row-${a.asset_id}`}>
      <td className="p-3">
        <p className="font-medium">{a.name}</p>
        <p className="text-[10px] text-muted-foreground">{[a.serial_number, a.location].filter(Boolean).join(' · ') || '—'}</p>
      </td>
      <td className="p-3"><Badge variant="outline" className="text-[10px]">{labels[a.category] || a.category}</Badge></td>
      <td className="p-3 text-xs whitespace-nowrap">{a.purchase_date}</td>
      <td className="p-3 text-xs">{METHOD_LABELS[a.method]} · {a.useful_life_years}y</td>
      <td className="p-3 text-right font-mono">{fmtCurrency(a.cost)}</td>
      <td className="p-3 text-right font-mono text-muted-foreground">{fmtCurrency(a.accumulated_depreciation)}</td>
      <td className="p-3 text-right font-mono font-semibold" data-testid={`asset-nbv-${a.asset_id}`}>{fmtCurrency(a.net_book_value)}</td>
      <td className="p-3">
        <Badge variant={active ? 'secondary' : 'outline'} className="text-[10px]" data-testid={`asset-status-${a.asset_id}`}>
          {active ? (a.fully_depreciated ? 'Fully depreciated' : 'Active') : 'Disposed'}
        </Badge>
      </td>
      <td className="p-3">
        <div className="flex justify-end gap-1">
          <Button variant="ghost" size="icon" className="h-7 w-7" title="Schedule" onClick={() => onSchedule(a)} data-testid={`asset-schedule-${a.asset_id}`}><LineChart className="h-3 w-3" /></Button>
          {active && <Button variant="ghost" size="icon" className="h-7 w-7" title="Edit" onClick={() => onEdit(a)} data-testid={`asset-edit-${a.asset_id}`}><Pencil className="h-3 w-3" /></Button>}
          {active && <Button variant="ghost" size="icon" className="h-7 w-7" title="Dispose" onClick={() => onDispose(a)} data-testid={`asset-dispose-${a.asset_id}`}><Archive className="h-3 w-3" /></Button>}
          <Button variant="ghost" size="icon" className="h-7 w-7 text-red-500" title="Delete" onClick={() => onDelete(a)} data-testid={`asset-delete-${a.asset_id}`}><Trash2 className="h-3 w-3" /></Button>
        </div>
      </td>
    </tr>
  );
};

export const AssetTable = ({ assets, ...rest }) => (
  <div className="border rounded-xl overflow-x-auto">
    <table className="w-full text-sm min-w-[860px]">
      <thead className="bg-muted/50 text-xs">
        <tr>
          {['Asset', 'Category', 'Purchased', 'Method', 'Cost', 'Acc. dep.', 'Book value', 'Status', ''].map((h, i) => (
            <th key={h || i} className={`p-3 font-medium ${i >= 4 && i <= 6 ? 'text-right' : 'text-left'}`}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>{assets.map((a) => <Row key={a.asset_id} a={a} {...rest} />)}</tbody>
    </table>
  </div>
);
